import http from "@/common/http.service";
const CAMPAIGN_SAVE = "campaign/save";
const SPAM_CHECK = "service/spam-check";
const TEST_MAIL_URL = "campaign/sentTest";
const HTML_TO_TEXT = "campaign/convert_to_text";
const AI_SUBJECTLINE = "panel/campaign/subjectline";
const AI_CLICKCOUNT = "panel/campaign/fetchrequest";
const PREVIEW_SIZE = "panel/campaign/previewsize";
const RECIPIENT_LIST = "campaign/recipient-list";
const SEGMENT_LIST = "campaign/segment-list";
const CAMPAIGN_DETAILS = "panel/preview/campaign_summary";
const CAMPAIGN_ETIMATE = "panel/campaign/estimate";
const REQUEST_AMP = "panel/campaign/allowAmp";
const CAMPAIGN_UPDATE = "panel/campaign/update/";
const CAMPAIGN_CREATE = "panel/campaign/save";
const BLACKLIST_CHECK = "/panel/campaign/blacklist-brokenlinks";
const LINK_CHECK = "campaign/update-broken-link";

export const getPreviewSize = (params) => {
  return http.post(PREVIEW_SIZE, params).then((response) => {
    return response;
  });
};

export const sentAmpRequest = (params) => {
  return http.post(REQUEST_AMP, params).then(({ status }) => {
    return status;
  });
};

export const getClickCount = (params) => {
  return http.post(AI_CLICKCOUNT, params).then((response) => {
    return response;
  });
};
export const generateSubLines = (params) => {
  return http.post(AI_SUBJECTLINE, params);
};
export const saveCampaign = (inputParams) => {
  let params = { ...inputParams };
  if (params.plaintext) {
    params.plaintext = Buffer.from(params.plaintext).toString("base64");
  }
  if (params.html) {
    params.html = Buffer.from(params.html).toString("base64");
  }
  if (params.tempJson) {
    params.tempJson = Buffer.from(params.tempJson).toString("base64");
  }
  return http.post(CAMPAIGN_SAVE, params).then((response) => {
    if (response.data && response.data.id) {
      var id = params.id ? params.id : response.data.id;
      var brokenLinks = response.data.brokenLinks
        ? JSON.parse(response.data.brokenLinks)
        : [];
      return { ...inputParams, ...response.data, brokenLinks, id };
    } else {
      throw response;
    }
  });
};

export const fetchSpamScore = (params) => {
  return http.post(SPAM_CHECK, params).then((response) => {
    var blacklist_details =
      response.data.blackListA && response.data.blackListA.details
        ? JSON.parse(response.data.blackListA.details)
        : {};
    var blacklist_links = response.data.blackListA
      ? response.data.blackListA.status
      : 2;
    return { blacklist_details, blacklist_links };
  });
};

export const testMail = (params) => {
  return http.post(TEST_MAIL_URL, params);
};

export const convertHtmlToText = (params) => {
  params = { ...params };
  params.html = Buffer.from(params.html).toString("base64");
  return http.post(HTML_TO_TEXT, params);
};

export const fetchContactLists = (params) => {
  return http.post(RECIPIENT_LIST, params).then(function (response) {
    return response;
  });
};

export const fetchSegmentLists = (params) => {
  return http.post(SEGMENT_LIST, params).then(function (response) {
    return response;
  });
};

export const fetchCampaignPreview = (params) => {
  return http
    .post(CAMPAIGN_DETAILS, params, null, null, "v2")
    .then(function (response) {
      return response;
    });
};

export const fetchCampaignEstimate = (params) => {
  return http.post(CAMPAIGN_ETIMATE, params, null, null, "v2");
};

export const updateCampaign = (id, params) => {
  return http.post(CAMPAIGN_UPDATE + id, params, null, null, "v2");
};

export const createCampaign = (params) => {
  if (params.id) {
    return updateCampaign(params.id, params, null, null, "v2");
  }
  return http.post(CAMPAIGN_CREATE, params, null, null, "v2");
};

export const blacklistCheck = (params) => {
  return http.post(BLACKLIST_CHECK, params, null, null, "v2");
};

export const linkCheck = (params) => {
  return http.post(LINK_CHECK, params);
};
